import createCache from "@emotion/cache"

const isBrowser = typeof document !== "undefined"

export default function createEmotionCache() {
  let insertionPoint

  if (isBrowser) {
    const emotionInsertionPoint = document.querySelector(
      'meta[name="emotion-insertion-point"]'
    )
    insertionPoint = emotionInsertionPoint ?? undefined
  }

  const cache = createCache({ key: "mui", insertionPoint, prepend: true })
  cache.compat = true

  return cache
}
